<template>
  <v-form v-if="program" @submit.prevent="save" ref="programForm" class="pa-3 white lighten-1">
    <v-layout row wrap>
      <v-flex xs12 md6 lg12 class="px-2">
        <!-- Program Name -->
        <v-text-field v-model="program.name" :label="$t('program.update.program_name')" color="primary" outline :rules="[rules.required, rules.min_length(3)]"></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg12 class="px-2">
        <!-- Description -->
        <v-textarea v-model="program.description" :label="$t('program.update.description')" color="primary" outline required></v-textarea>
      </v-flex>
      <v-flex xs12 md6 lg6 class="px-2">
        <!-- Start Date -->
        <DateTimePicker
          name="start_date"
          key="program_startdate"
          :label="$t('program.form.start_date')"
          datetime="start_date"
          v-model="program.starts_at"
          :rules="[rules.required]"
        />
        <!-- Showing local time regarding company configured timezone -->
        <ShowLocalTime
          v-if="program.starts_at"
          key="start_date"
          :datetime="program.starts_at"
          :timezone="timezone"
        ></ShowLocalTime>
      </v-flex>
      <v-flex xs12 md6 lg6 class="px-2">
        <!-- End Date -->
        <DateTimePicker
          name="end_date"
          key="program_end_date"
          :label="$t('program.form.end_date')"
          datetime="end_date"
          v-model="program.ends_at"
          :rules="[rules.required]"
        />
        <!-- Showing local time regarding company configured timezone -->
        <ShowLocalTime
          v-if="program.ends_at"
          key="end_date"
          :datetime="program.ends_at"
          :timezone="timezone"
        ></ShowLocalTime>
      </v-flex>
      <!-- Program section 1 -->
      <v-flex xs12 md12 lg12 class="px-2 py-3">
        <v-card elevation="2">
          <v-card-title>
            <h3>
              Video/Play Section
            </h3>
          </v-card-title>
          <v-card-title>
            <v-layout wrap row>
              <v-flex xs6>
                <v-tabs
                  background-color="transparent"
                  color="basil"
                  grow
                  v-model="language_section_1"
                >
                  <v-tab
                   v-for="language in enabledLanguages" :key="language.text"
                  >
                    {{ language.text }}
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex xs6>
                <div style="float: right;" v-if="language_section_1 === 0">
                  <v-tooltip 
                    bottom
                    max-width="300"
                    color="grey darken-3"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-3"
                        class="override-btn"
                        outlined
                        style="float:right"
                        small
                        @click="setFieldLanguageData(['title','description'], program.film_play_section)"
                      >
                      {{ $t('language_copy_all_button_label') }}
                      </v-btn>
                    </template>
                    <div class="pa-2">
                      <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                    </div>
                  </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-tabs-items v-model="language_section_1">
              <v-tab-item
                v-for="language in enabledLanguages"
                :key="language.text"
              >
                <v-card
                  color="basil"
                  flat
                >
                  <v-card-text>
                    <v-flex xs12 md6 lg12 class="px-2">
                      <v-text-field :label="`Section title in ${language.text}`" v-model="program.film_play_section.title[language.value]"  color="primary" outline :rules="[rules.min_length(3)]"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg12 class="px-2">
                      <TextEditor :title="`Section Description in ${language.text} `"  v-model="program.film_play_section.description[language.value]" />
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- Program section 1 -->

      <!-- Program section 2 -->
      <v-flex xs12 md12 lg12 class="px-2 py-3">
        <v-card elevation="2">
          <v-card-title>
            <h3>
              Q & A  Section
            </h3>
          </v-card-title>
          <v-card-title>
            <v-layout row wrap>
              <v-flex xs6>
                <v-tabs
                  background-color="transparent"
                  color="basil"
                  grow
                  v-model="language_section_2"
                >
                  <v-tab
                  v-for="language in enabledLanguages" :key="language.text"
                  >
                    {{ language.text }}
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex xs6>
                <div style="float: right;" v-if="language_section_2 === 0">
                  <v-tooltip 
                    bottom
                    max-width="300"
                    color="grey darken-3"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-3"
                        class="override-btn"
                        outlined
                        style="float:right"
                        small
                        @click="setFieldLanguageData(['title','description'], program.question_answer_section)"
                      >
                      {{ $t('language_copy_all_button_label') }}
                      </v-btn>
                    </template>
                    <div class="pa-2">
                      <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                    </div>
                  </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-tabs-items v-model="language_section_2">
              <v-tab-item
                v-for="language in enabledLanguages"
                :key="language.text"
              >
                <v-card
                  color="basil"
                  flat
                >
                  <v-card-text>
                    <v-flex xs12 md6 lg12 class="px-2">
                      <v-text-field :label="`Section title in ${language.text}`" v-model="program.question_answer_section.title[language.value]"  color="primary" outline :rules="[rules.min_length(3)]"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg12 class="px-2">
                      <TextEditor :title="`Section Description in ${language.text}`" v-model="program.question_answer_section.description[language.value]" />
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- Program section 2 -->

      <v-flex xs12 md12 lg12 class="px-2">
        <!-- Active Checkbox -->
        <v-checkbox v-model="program.status" :label="$t('program.update.active')" color="primary" hide-details></v-checkbox>
        <div class="mt-2 grey--text greyDarken2--text" v-html="$t('program.update.active.warning')">
        </div>
      </v-flex>
      <!-- Submit and Cancel Buttons -->
      <v-flex xs12 class="px-2 text-lg-right">
        <v-btn color="grey" dark @click="cancel">{{ $t("program.update.cancel") }}</v-btn>
        <v-btn color="primary" @click="save">{{ $t("program.update.save") }}</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import DateTimePicker from "@/components/DateTimePicker";
import ShowLocalTime from "@/components/ShowLocalTime";
import TextEditor from "@/components/TextEditor";

import { mapGetters, mapState } from 'vuex';
import rules from "@/validation";

export default {
  name: "ProgramForm",
  props: {
    program: {
      type: Object,
      default: null,
    },
  },
  components: { DateTimePicker, TextEditor, ShowLocalTime },
  data() {
    return {
      rules,
      language_section_1:null,
      language_section_2:null,
    };
  },
  computed: {
    ...mapState({
      company: (state) => state.company.company,
    }),
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
      currentCompanyId:'getSelected'
    }),
    enabledLanguages() {
        if (this.company) {
            return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : this.i18n_locale; 
        }else{
            return this.i18n_locale
        }
    }
  },
  watch:{
    program: {
      deep: true,
      handler: function () {
        this.$emit("update:program", this.program);
      },
    },
  },
  methods: {
    save() {
      if (!this.$refs.programForm.validate()) {
        return;
      }
      this.$emit("update");
    },
    cancel() {
      this.$emit("cancel");
    },
    setFieldLanguageData(fields, stateObject) {
      let __this = this
      fields.forEach(field => {
        __this.enabledLanguages.forEach((lang) => {
          if (lang.value !== 'en') {
            stateObject[field][lang.value] = stateObject[field]['en']
          }
        });
      });
    }
  }
};
</script>

<style>
/* Add any necessary styles here */
</style>
